var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',_vm._b({class:_vm.classes.join(' '),domProps:{"textContent":_vm._s(_vm.title)},on:{"click":_vm.onClick}},'v-chip',_vm.buttonBind,false))
}
var staticRenderFns = []

export { render, staticRenderFns }